module.exports = __webpack_public_path__ + "static/media/menuList.7d58dfec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuList.svg
// module id = 491
// module chunks = 0